import styled from '@emotion/styled';
import { createElement, FC, ReactElement } from 'react';

import { SPACING_REGULAR } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import mq from '../../../styleUtility/mediaquery';
import EmptyState from './EmptyState';
import FinalizedState from './FinalizedState';
import { Props as ItemProps } from './Item';

interface Props {
  proposal: boolean;
  finalized?: boolean;
  className?: string;
  children: ReactElement<ItemProps>[];
}

const CreationsList: FC<Props> = ({ proposal, finalized, className, children }) => {
  if (proposal && finalized) {
    return <FinalizedState className={className} />;
  } else if (children.length === 0) {
    return <EmptyState proposal={proposal} className={className} />;
  } else {
    return <Root className={className}>{children}</Root>;
  }
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    wrap: 'wrap',
    alignContent: 'stretch',
  }),
  {
    '& > *': {
      width: `calc((100% - ${SPACING_REGULAR}px * 2) * 0.333)`, // Do not use `/ 3`, Because broken layout with Edge.
      marginBottom: SPACING_REGULAR,
      marginRight: SPACING_REGULAR,
      ':nth-of-type(3n)': {
        marginRight: 0,
      },
    },
    [mq('sp')]: {
      '& > *': {
        width: `calc((100% - ${SPACING_REGULAR}px ) * 0.5)`, // Do not use `/ 3`, Because broken layout with Edge.
        ':nth-of-type(3n)': {
          marginRight: SPACING_REGULAR,
        },
        ':nth-of-type(2n)': {
          marginRight: 0,
        },
      },
    },
  },
);

export default CreationsList;
